<template>
  <div class="list">
    <home-banner ref="homeBanner" :height="400"></home-banner>
    <div class="clear"></div>
    <div class="listMain wrap">
      <div class="listMainBox">
       <div class="listMainLeft fl">
           <div class="listSlidHd">
              <div class="pic">
                <img src="../assets/img/zi_left_b.png" alt="">
              </div>
              <div class="title">
                {{slideHdParentName}}
              </div>
              <div class="txt">
                匠心营造 精益求精
              </div>
            </div>
          <div class="listSlid">
            <div class="listSlidList">
              <div class="listSlidList_line" v-for="(item, index) in slideList" :key="index" >
                <div class="listSlidListInner" :class="{on : active  == item.entTChannelUuid}">
                  <!-- <a 
                  v-if="item.url && item.url !== ''" 
                  target="_blank" 
                  :href="item.url">
                  {{item.name}}
                  </a>
                  <a 
                    v-if="!item.url || item.url == ''" 
                    :href="item.catalog === 1 ? `/listPage/${item.entTChannelUuid}` : item.catalog === 2 ? `/list/${item.entTChannelUuid}` : `/listPic/${item.entTChannelUuid}`">
                    {{item.name}}
                  </a> -->

                  <!-- <a 
                    v-if="item.child.length && item.child[0].url && item.child[0].url !== ''" 
                    target="_blank"
                    :href="item.url">
                    {{item.name}}
                  </a> -->
                  <a 
                    v-if="item.child.length && (!item.child[0].url || item.child[0].url == '')" 
                    :href="item.catalog == 1 ? `/listPage/${item.child[0].entTChannelUuid}` : item.catalog == 2 ? `/list/${item.child[0].entTChannelUuid}` : `/listPic/${item.child[0].entTChannelUuid}`">
                    {{item.name}}
                  </a>
                  <a 
                    v-if="!item.child.length" 
                    :href="item.catalog == 1 ? `/listPage/${item.entTChannelUuid}` : item.catalog == 2 ? `/list/${item.entTChannelUuid}` : `/listPic/${item.entTChannelUuid}`">
                    {{item.name}}
                  </a>
                  
                </div>
                <div class="thirdNav" v-if="item.child.length != 0">
                  <div class="thirdNav_line" v-for="(item1, index1) in item.child" :key="index1" :class="{on : item1.name == isClickid2}">
                    <a 
                      v-if="item1.url && item1.url !== ''" 
                      target="_blank" 
                      :href="item1.url">
                      {{item1.name}}
                    </a>
                    <a 
                      v-if="!item1.url || item1.url == ''" 
                      :href="item1.catalog === 1 ? `/listPage/${item.entTChannelUuid}` : item1.catalog === 2 ? `/list/${item1.entTChannelUuid}` : `/listPic/${item1.entTChannelUuid}`">
                      {{item1.name}}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="listMainRight fr">
          <div class="listWrap">
            <div class="listHd clearfloat">
              <div class="listpot">{{slideHdTitle}}</div>
              <div class="fl listHdGrop">
                <span class="listHdIco"><i class="el-icon-s-home"></i></span> 您当前所在位置：<a href="/">首页</a> > <span v-if="viewSlideHdParent"><a :href="slideHdParentUrl">{{slideHdParentName}}</a> </span> <span v-if="slideHdName2!=''" class="txt">> {{slideHdName2}} </span><span v-if="isthird" class="txt">> {{slideHdName1}}</span>
              </div>
            </div>
            <div class="listContainer">
              <div class="newList">
                <ul>
                  <li v-for="(item,index) in listData" :key="index" >
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank" title="">
                      <div class="lf">
                        <b >{{item.title | ellipsis2}}</b>
                        <p>{{item.artDesc | ellipsis}}</p>
                      </div>
                      <div class="ri">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                    </a>
                    <a v-else-if="(!item.url || item.url == '') && item.entTChannelUuid =='00190001'" target="_blank" :href="`/detail/yiji00020002/${item.entTArticleUuid}`">
                      <div class="lf">
                        <b >{{item.title | ellipsis2}}</b>
                        <p>{{item.artDesc | ellipsis}}</p>
                      </div>
                      <div class="ri">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                    </a>
                    <a v-else :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`" target="_blank" title="">
                      <div class="lf">
                        <b >{{item.title | ellipsis2}}</b>
                        <p>{{item.artDesc | ellipsis}}</p>
                      </div>
                      <div class="ri">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="listPage" v-if="listData.length!=0">
                <el-pagination background layout="prev, pager, next" :current-page="pageNum" :page-size="pageSize" :total="total" :pager-count="11" @current-change="currentChange" style="text-align:center;">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import homeBanner from "@/components/swiper.vue"
  import {
    getChildChannel,
    getChannelInfo,
    articles,
    // getAllArtListByParentUuid
  } from '@/api/common'

  export default {
    name: 'list',
    components: {
      homeBanner
    },
    data() {
      return {
        isthird: false,
        isClickid: '',
        isClickid2: '',
        slideHdName1: '',
        slideHdName2: '',
        slideHdTitle: '',
        viewSlideHdParent: true,
        slideHdParentName: '',
        slideHdParentUrl:'',
        slideHdName: '',
        hdTitle: '',
        hdName: '',
        pageCont: '',
        active: 0,
        slideHd: {
          title: '新闻动态',
        },
        slideList: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        listData: [],
        listId: ''
      }
    },
    filters: {
    ellipsis: function(value) {
      if (!value) return "";
      if (value.length > 120) {
        return value.slice(0, 120) + "...";
      }
      return value;
    },
    ellipsis2: function(value) {
      if (!value) return "";
      if (value.length > 45) {
        return value.slice(0, 45) + "...";
      }
      return value;
    },
  }, 
    mounted() {
      var _this = this
      _this.active = _this.$route.params.id
      _this.listId = _this.$route.params.id
      // _this.getChildChannel()
      _this.getChannelInfo()
      _this.articles()
    },
    methods: {
      // 查询二级栏目
      getChildChannel(id) {
        var _this = this

        let data = {
          applicationUuid: _this.webId,
          parentUuid: id
        }
        getChildChannel(data).then(res => {
          const {
            code,
            data
          } = res
          if (code === 1 && data) {
            _this.slideList = data
            if (_this.slideList.length) {
              _this.viewSlideHdParent = true
              let url = ''
              if (_this.slideList[0].catalog === 1) {
                url = `/listPage/${_this.slideList[0].entTChannelUuid}`
              } else if (_this.slideList[0].catalog === 2) {
                url = `/list/${_this.slideList[0].entTChannelUuid}`
              } else {
                url = `/listPic/${_this.slideList[0].entTChannelUuid}`
              }
              _this.slideHdParentUrl = url
            } else {
              _this.viewSlideHdParent = false
            }
          }
        })
      },
      getChannelInfo() {
        var _this = this
        let params1 = {
          channelUuid: _this.$route.params.id
        }
        getChannelInfo(params1).then(res => {
          const {
            code,
            data
          } = res
          if (code === 1 && data) {
            if( data.parentUuid=="0" ){
              _this.slideHdTitle = data.name
              _this.slideHdParentName = data.name
              return
            }
            _this.slideHdName1 = data.name
            let params2 = {
              channelUuid: data.parentUuid
            }
            getChannelInfo(params2).then(res => {
              const {
                code,
                data
              } = res
              if (code === 1 && data) {
                if (data.parentUuid == '0') {
                  _this.getChildChannel(data.entTChannelUuid)
                  _this.slideHdParentName = data.name
                  _this.slideHdName2 = _this.slideHdName1
                  _this.slideHdTitle = _this.slideHdName2
                  _this.isthird = false
                } else {
                  _this.isthird = true
                  _this.getChildChannel(data.parentUuid)
                  _this.slideHdName2 = data.name
                  _this.isClickid = data.channelId
                  let params3 = {
                    channelUuid: data.parentUuid
                  }
                  getChannelInfo(params3).then(res => {
                    const {
                      code,
                      data
                    } = res
                    if (code === 1 && data) {
                      _this.slideHdParentName = data.name
                      _this.slideHdTitle = _this.slideHdName1
                      _this.isClickid2 = _this.slideHdName1
                    }
                  })
                }
              }
            })
          }
        })
       
      },
      // 获取列表
    articles() {
      var _this = this
      let id = ''
      var applicationId = ''
      if(_this.$route.params.id == 'yiji00020002')
      {
        id= '00190001'
        applicationId = _this.webIdGroup
      }
      else{
        id =  _this.$route.params.id
        applicationId = _this.webId
      }
      let data = {
        // channelUuid: _this.$route.params.id,
        entTApplicationUuid: applicationId,
        channelUuid : id,
        pageNum: _this.pageNum,
        pageSize: _this.pageSize
      }
          articles(data).then(res => {
            const {
              code,
              data
            } = res
            if (code === 1 && data) {
              _this.listData = data.rows
              _this.total = data.totalRows
            }
          })
      },
      currentChange(e) {
        // console.log('e :>> ', e);
        var _this = this
        _this.pageNum = e
        _this.articles()
      }
    }
  }
</script>
<style>
.listSlidListInner.on a {
    background-color: #0062b3;
    color: #FFFFFF;
}
.contactBody {
  width: 100%;
  min-height: 500px;
  line-height: 30px;
}
.listSlidList{
  margin-top: 100px;
}
.listSlidHd{
 width: 235px;
 height: 230px;
 background-color: #0062b3;
 color: #FFFFFF;
 position: absolute;
 margin-top: -111px;
 z-index: 9999999;
}
.listSlidHd .pic {
 width: 64px;
 height: 73px;
 margin: 26px auto 0px auto;
}
.listSlidHd .title {
 width: 100%;
 height: 54px;
 line-height: 34px;
 text-align: center;
 font-size: 24px;
 margin-top: 4px;
}
.listSlidHd .txt {
 height: 24px;
 line-height: 24px;
 text-align: center;
 font-size: 16px;
 text-align: center;
 color: #97bde1;
 margin-top: 10px;
}
  .listSlidList_line{
    width: 100%;
    height: 50px;
    display: block;
    background-color: #e8e8e8;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
    /* color: #000; */
    margin-bottom: 5px;
    font-weight: bolder;
  } 
.listSlidListInner:hover {
    background-color: #0062b3;
    color: #fff;
}
.listSlidListInner a:hover {
    color: #fff;
}
.wrap {
  height:auto;
}
.listMain {
  height: auto;
  overflow: hidden;
}
/* .wrap{
  height:897px;
}
.listMain{
  height: 1010px;
} */
.listSlid{
  width: 235px;
  height: auto;
  margin-top: 126px;
}
.listpot{
    width: 300px;
    height: 35px;
    line-height: 35px;
    float: left;
    font-size: 14px;
}
.listHdGrop{
    width: 600px;
    text-align: right;
    height: 25px;
    line-height: 25px;
    margin-top: 10px;
    float: right;
    font-size: 12px;
    color: #9a9a9a;
}
.listHdGrop a {
    font-size: 12px;
    color: #9a9a9a;
}
.listHd {
    width: 100%;
    height: 35px;
    border-bottom: 1px solid #d6d6d6;
} 
  .listContainer{
    padding: 0 10px;
    margin-bottom: 25px;
  }
  .listContainer .contactBody p {
    padding: 0;
    line-height: 3em;
    text-indent: 0;
    font-family: 宋体;
    font-size: 18px;
    line-height: 28px;
    margin: 5px 0;
}
.newList{
  margin-bottom: 20px;
}
.thirdNav .thirdNav_line {
    margin: 0 0 3px 0;
    padding: 0;
    width: 100%;
    height: 30px;
    display: block;
    line-height: 30px;
    text-align: center;
    font-size: 13px;
    /* color: #000; */
    margin-bottom: 3px;
    font-weight: 400;
    background: none;
}
.thirdNav .thirdNav_line.on a{
  background-color: #0062b3;
    color: #fff;
}
.thirdNav_line a {
    font-size: 14px;
    font-weight: normal;
    text-align: center;
    display: block;
    widows: 235px;
}
.thirdNav_line:hover {
    background-color: #0062b3;
    color: #fff;
}
.thirdNav_line a:hover {
    color: #fff;
}
.listWrap{
  width: 930px;
}
/* .listMainRight{
      width: 910px;
    margin-left: 270px;
    margin-bottom: 20px;
} */
</style>